import { colors } from '../../colors';
var location = {
  bgColor: colors.white,
  cardBgColor: colors.white,
  secondaryBgColor: colors.white,
  cardShadow: colors.black,
  cardRadius: '20px',
  backgroundWave: true
};
export default location;